import { ActionOnFieldHandler } from './ActionOnFieldHandler';
import { BeforeSubmitTestData } from '../event/BeforeSubmitTestEventHandler';

export class SubmitTestAction extends ActionOnFieldHandler {
  constructor() {
    super('submitTest');
  }

  handleAction(
    action: any,
    data: BeforeSubmitTestData,
    subActionHandle?: (action: any) => Promise<void>
  ): Promise<void> {
    if (this.canHandleAction(action)) {
      data.onSubmit(data);
    }
    return Promise.resolve();
  }
}
